/**
 * @fileoverview superclass of controllers for compliance settings
 * Provides save/cancel buttons and toggling between edit and view modes
 *
 * @author pterry@yext.com
 */
goog.module('yext.storm.IndividualComplianceSettingView');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const Model = goog.require('yext.mvc.Model');
const View = goog.require('yext.mvc.View');

/**
 * @constructor
 * @extends {View}
 */
const IndividualComplianceSettingView = function() {
  /** @type {!jQuery} */
  this.$viewMode = this.$el.find('.js-view-mode');

  /**
   * @type {Model}
   */
  this.model = new Model();

  /**
   * @type {!Object}
   * @private
   */
  this.originalState_ = null;
};
goog.inherits(IndividualComplianceSettingView, View);

/** @enum */
IndividualComplianceSettingView.Mode = {
  VIEW: 1,
  EDIT: 2,
};

IndividualComplianceSettingView.prototype.init = function() {
  this.initModel_();
  this.bindModelToRender_();
  this.bindToggleEdit_();
  this.bindSubmit();
  this.doAdditionalBinding();
  this.renderDisplay();

  return this;
};

/** @public */
IndividualComplianceSettingView.prototype.doAdditionalBinding = function() {};

/** @private */
IndividualComplianceSettingView.prototype.initModel_ = function() {
  var baseModelProperties = {
    'mode': IndividualComplianceSettingView.Mode.VIEW,
    'errors': [],
  };
  this.model.init($.extend({}, baseModelProperties, this.getAdditionalModelProperties()));

  this.originalState_ = this.model.raw();
};

/**
  * Provide subclass-specific properties for initializing the model
  * @public
  */
IndividualComplianceSettingView.prototype.getAdditionalModelProperties = function() {
  return {};
};

/** @private */
IndividualComplianceSettingView.prototype.bindModelToRender_ = function() {
  this.model.on('reset,change:mode', function() {
    this.render();
  }.bind(this));

  this.model.on('change', function() {
    this.renderSubmit_();
    this.renderDisplay();
  }.bind(this));

  this.model.on('change:errors', function() {
    this.renderErrors_();
  }.bind(this));
};

/** @private */
IndividualComplianceSettingView.prototype.bindToggleEdit_ = function() {
  this.$el.on('click', function() {
    this.model.set('mode', IndividualComplianceSettingView.Mode.EDIT);
  }.bind(this));

  this.$el.find('.js-cancel').on('click', function(e) {
    e.stopPropagation();
    this.model.resetState(this.originalState_);
    this.model.set('mode', IndividualComplianceSettingView.Mode.VIEW);
    this.resetInput();
  }.bind(this));
};

/** @public */
IndividualComplianceSettingView.prototype.resetInput = function() {
  // NOTE(pterry): Do nothing by default; can override in subclass
};

/** @public */
IndividualComplianceSettingView.prototype.bindSubmit = function() {
  this.$el.find('form').on('submit', function(e) {
    e.stopPropagation();
    e.preventDefault();
    this.callSubmitUrl();
  }.bind(this));
};

/** @public */
IndividualComplianceSettingView.prototype.callSubmitUrl = function() {
  $.ajax({
    'url': this.getSubmitUrl(),
    'type': 'POST',
    'data': this.getData(),
  })
    .done(function(data) {
      if (data['success']) {
        this.model.set(
          'mode',
          IndividualComplianceSettingView.Mode.VIEW);
        this.originalState_ = this.model.raw();
      } else if (data['error']) {
        this.model.set('errors', data['errors']);
      }
    }.bind(this))
    .fail(function() {
      this.model.set(
        'errors',
        [yext.msg('There was an error saving your changes. Please try again')]);
    }.bind(this));
};

/** @public */
IndividualComplianceSettingView.prototype.getData = function() {
  throw new Error('Not implemented');
};

/** @public */
IndividualComplianceSettingView.prototype.getSubmitUrl = function() {
  throw new Error('Not implemented');
};

/**
 * @private
 * @return true if there have been any changes to the form
 */
IndividualComplianceSettingView.prototype.hasChanges_ = function() {
  var changes = this.model.findDelta(this.originalState_).delta;
  for (var k in changes) {
    if (k == 'mode' || k == 'errors') {
      continue;
    } else {
      return true;
    }
  }
  return false;
};

/** @override */
IndividualComplianceSettingView.prototype.render = function() {
  this.renderMode_();
  this.renderDisplay();
  this.renderErrors_();
};

/** @private */
IndividualComplianceSettingView.prototype.renderErrors_ = function() {
  var errors = this.model.get('errors');
  if (errors && errors.length) {
    this.$el.find('.js-error').html(errors.join('<br/>')).show();
  } else {
    this.$el.find('.js-error').empty().hide();
  }
};

/** @private */
IndividualComplianceSettingView.prototype.renderMode_ = function() {
  this.$el
    .find('.js-edit-mode')
    .toggle(this.model.get('mode') ==
      IndividualComplianceSettingView.Mode.EDIT);
  this.$viewMode
    .toggle(this.model.get('mode') ==
      IndividualComplianceSettingView.Mode.VIEW);
};

/** @private */
IndividualComplianceSettingView.prototype.renderSubmit_ = function() {
  this.$el.find('.js-submit').prop('disabled', !this.hasChanges_());
};

/** @public */
IndividualComplianceSettingView.prototype.renderDisplay = function() {
  throw new Error('Not implemented');
};

exports = IndividualComplianceSettingView;
